<lib-select
  class="lang-select"
  *ngIf="langOptions$ | async as langOptions"
  optionImgWidth="16px"
  [noBackground]="true"
  [withTrigger]="true"
  [dropdownIconsPath]="dropdownIconsPath"
  [options]="langOptions"
  [value]="langFormControl.value"
  (valueChange)="handleLangChange($any($event))"
>
  <div *ngIf="getLangOption(langFormControl.value, langOptions) as langOption">
    <div [ngSwitch]="langOption.key">
      <img [src]="langOption.img" /> <span>&nbsp;{{ langOption.key }}</span>
    </div>
  </div>
</lib-select>
